import Utilities from '@/components/utilities/index.vue'

export default {
  components: {
    Utilities
  }
}
